/**
 * Standard Actions, for the Canvello bag (Task 5; Dawn's version drove its
 * <cart-drawer>, which is gone).
 *
 * Storefront Renderer injects the Shopify Standard Actions bundle
 * (`window.Shopify.actions.{updateCart,openCart,getCart,…}`), which
 * assistants and Shopify's own surfaces call. Here:
 *   - openCart   — opens the bag drawer (assets/cv-bag.js); on the cart
 *                  page, or with the drawer off, the default (/cart).
 *   - updateCart — after the Storefront API mutation, fires cart:updated
 *                  with the new cart and open: false, so the bag refreshes
 *                  and the header's count follows without the drawer
 *                  popping open; Dawn's pubsub cart-update is published
 *                  too, for anything still listening.
 *   - other actions (getCart, etc.) keep the default implementation.
 */

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.openCart.configure({
    async handler(defaultHandler) {
      if (document.querySelector('cv-bag-drawer') && window.CVBag) {
        window.CVBag.open();
        return;
      }
      return defaultHandler();
    },
  });

  actions.updateCart.configure({
    // The bundle requires an eventTarget; document is the conventional root.
    eventTarget: () => document,
    async handler(defaultHandler) {
      const result = await defaultHandler();
      try {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        const cart = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null));
        if (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, item_count: cart.item_count, source: 'standard-actions', open: false } }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'external-refresh', cartData: cart });
          }
        }
        if (document.querySelector('[data-cv-cart]') && window.CVBag) await window.CVBag.refresh();
      } catch (error) {
        console.error('[Canvello] Standard Actions cart refresh failed; reloading.', error);
        window.location.reload();
      }
      return result;
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  initStandardActions();
} else {
  document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
}
